/* projects/erp/src/app/app.component.css */
.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url("./media/bg-central.png");
  background-color: #F1F1F2;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: bottom;
}
.circle {
  border-radius: 50%;
}
.with-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}
.no-shadow {
  box-shadow: none !important;
}
::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}
.bottom-to-top {
  border: 0px;
  border-right: 1px;
  border-style: solid;
  border-image:
    linear-gradient(
      to top,
      #c1c1c1,
      rgba(0, 0, 0, 0)) 1 100%;
}
mat-sidenav {
  width: 250px;
}
.circle {
  border-radius: 50%;
}
.with-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}
.no-shadow {
  box-shadow: none !important;
}
::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}
.bottom-to-top {
  border: 0px;
  border-right: 0px;
  border-style: solid;
  border-image:
    linear-gradient(
      to top,
      #c1c1c1,
      rgba(0, 0, 0, 0)) 1 100%;
}
.sidemenu-back {
  background: url("./media/bg-menu.png");
  background-color: #606062;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: bottom;
}
.back-central {
  background: url("./media/bg-central.png");
  background-color: #F1F1F2;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: bottom;
  position: absolute !important;
  bottom: 0px;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=app.component.css.map */
